<template>
    <div>
        <v-dialog v-model="compdialog" persistent>
            <v-card class="ticket_dialogue">
                <h3 class="maincolor ticket_dialogue_title">{{ title }}使用認証</h3>
                <p class="ticket_dialogue_text">店舗の管理アプリにてQRコードを読み取ってもらうか、読み取りができない場合は店舗の認証コードを入力してもらうことで利用できます</p>

                <div class="qrblc">
                    <qrcode :value="qrcodeurl" :options="{ width: 135, margin: 0 }"></qrcode>
                </div>

                <p class="authcode_text">認証コードを入力してください</p>
                <v-form ref="form" @submit.prevent="submit">
                    <v-text-field style="text-align:center;" class="authfield px-12" v-model="authcode" :error-messages="authcodeErrors" maxlength="4" type="password" label="認証コードを入力" @input="$v.authcode.$touch()" @blur="$v.authcode.$touch()"></v-text-field>
                    <div class="text-center pt-1 pb-4">
                        <v-btn rounded :disabled="!authcode || authcodeErrors.length > 0 || btnDisabled" class="maincolor-bg default_button" @click.stop="use()" >{{ title }}を使用する</v-btn>
                    </div>
                    <div class="text-center pb-6">
                        <v-btn small rounded class="graybtn" @click="close">キャンセルする</v-btn>
                    </div>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, numeric } from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],
    validations: {
        authcode: { required, numeric, maxLength: maxLength(4) },
    },
    props: ['data', 'init'],

    data: () => ({
        compdialog: false,
        authcode: '',
        ticket_id: null,
        authcode_flg: null,
        qrcodeurl: null,
        item: null,
        title: null,
        btnDisabled: false
    }),

    computed: {
        authcodeErrors() {
            const errors = []
            if (!this.$v.authcode.$dirty) return
            errors
            !this.$v.authcode.maxLength && errors.push('認証コードが違います')
            !this.$v.authcode.required && errors.push('認証コードを入力してください')
            !this.$v.authcode.numeric && errors.push('数字のみを入力してください')
            return errors
        },
    },

    methods: {
        use() {
            if (this.btnDisabled) return
            
            this.btnDisabled = true
            this.compdialog = false
            this.$emit('use', this.authcode)
        },
        open(title_type, id, flg, qr_url, item) {
          this.title = title_type == 1 ? 'チケット' : 'クーポン' //1: チケット、2:クーポン
          this.item = item
          this.ticket_id = id
          this.authcode_flg = flg
          //this.qrcodeurl = "" + id + "" + this.init.uid //仕様きまってから変更
          this.qrcodeurl = qr_url
          this.compdialog = true
        },
        close() {
          this.compdialog = false
          this.$emit('pollingStop')
        },
        submit() {
          this.$v.$touch()
        },
        clear() {
            this.$v.$reset()
            this.authcode = ''
        },
        setBtnDisabled(flg) {
            //「{{ title }}を使用する」ボタンのdisabledへ設定
            this.btnDisabled = flg
        }
    },
}
</script>

<style scoped>
/* override */

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 15px;
}

.ticket_dialogue {
    padding: 16px;
}

.ticket_dialogue_title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 0 0 15px;
}

.ticket_dialogue_text {
    font-size: 13px;
    line-height: 20px;
    color: #333333;
}

.qrblc {
    width: 60%;
    margin: 0 auto 20px;
    padding: 20px;
    background-color: #F9F9F9;
}

.authcode_text {
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    margin: 0 0 0;
}

.v-label {
    font-size: 14px !important;
}

.authfield>>>label {
    font-size: 13px;
    text-align: center;
}

.authfield>>>input {
    text-align: center;
}
</style>
